import { render } from "./Literatur.vue?vue&type=template&id=af0dad44&scoped=true"
import script from "./Literatur.vue?vue&type=script&lang=js"
export * from "./Literatur.vue?vue&type=script&lang=js"

import "./Literatur.vue?vue&type=style&index=0&id=af0dad44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af0dad44"]])

export default __exports__